export default __webpack_public_path__ + "static/media/review14.f14c571f.jpg";